import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=074cb61a&scoped=true"
var script = {}
import style0 from "./main-footer.vue?vue&type=style&index=0&id=074cb61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074cb61a",
  null
  
)

export default component.exports